import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { BarChartAxisType } from '../../../models';
import { ModalService } from '../../../services';

@Component({
  selector: 'app-line-chart-modal',
  templateUrl: './line-chart-modal.component.html',
  styleUrl: './line-chart-modal.component.css',
})
export class LineChartModalComponent<T> {
  @Input() yAxisName: string = '';
  @Input() xKey: string = '';
  @Input() yKey: string = '';
  @Input() yKey2: string = '';
  @Input() header: string = '';
  @Input() xAxisName: string = '';
  @Input() yName: string = '';
  @Input() yName2: string = '';
  @Input() yFormat: BarChartAxisType;
  @Input() xRotation: number;
  @Input() data$: Observable<T[]>;

  constructor(private modalService: ModalService) {}

  onClose() {
    this.modalService.dismiss();
  }
}
